export function getImageURL(url, fromNTD = false) {
  if (url?.startsWith("http")) {
    return url;
  } else {
    return `${fromNTD ? process.env.NEXT_PUBLIC_PROFILE_PICTURE_DOMAIN : process.env.NEXT_PUBLIC_IMG_PREFIX || ""}${url}`;
  }
}
